// Select.js
import React from 'react';

export const Select = ({ label, value, onChange, options = [], className = '', ...props }) => {
    return (
        <div className="flex flex-col gap-1 w-full">
            {label && (
                <label className="text-xs font-semibold text-neon-blue uppercase tracking-wider font-orbitron">
                    {label}
                </label>
            )}
            <select
                value={value}
                onChange={onChange}
                className={`
          flex h-9 w-full rounded-md border border-gray-700 bg-cyber-gray px-3 py-1 text-sm shadow-sm transition-all 
          text-gray-100 font-rajdhani
          focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-neon-blue focus-visible:border-neon-blue
          disabled:cursor-not-allowed disabled:opacity-50
          ${className}
        `}
                {...props}
            >
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value} className="bg-cyber-gray text-white">
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
